import React from 'react'
import { graphql } from 'gatsby'
import { useIntl } from 'gatsby-plugin-intl'

import Layout from 'components/layout'
import MetaTags from 'components/MetaTags'
import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import Heading from 'components/Heading'
import List from 'components/List'
import FeatureBox from 'components/FeatureBox'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'

const PetsWelcome = ({ data }) => {
  const {
    headerImage: {
      childImageSharp: { fluid },
    },
  } = data
  const intl = useIntl()

  // Content in both languages
  const content = {
    'en-us': {
      eyebrow: 'Pet Policy',
      heading: 'Pets Welcome at Our Hotel',
      subheading: 'Your Furry Friends Are Family Too',
      intro:
        'At Hotel Griffintown, we understand that your pets are family. We welcome well-behaved pets and have created a comfortable environment for both you and your four-legged companions.',
      directBookingBenefit:
        'Book directly with us and we waive the pet fee! This exclusive benefit is only available when you book through our website or call us directly.',
      policies: [
        'Maximum of 2 pets per apartment',
        'Pets must be house-trained and well-behaved',
        'Guests are responsible for any damage caused by pets',
        'Pets must be leashed in common areas',
        'Pet fee: $45 per night (waived for direct bookings)',
      ],
      amenities: [
        'Pet-friendly apartments with easy access',
        'Nearby parks and walking areas',
        'Pet waste stations throughout the property',
        'Pet-friendly dining options nearby',
      ],
      servicesTitle: 'Pet Services & Amenities',
      policiesTitle: 'Pet Policies & Guidelines',
    },
    'fr-ca': {
      eyebrow: 'Politique animaux',
      heading: 'Animaux bienvenus à notre hôtel',
      subheading: 'Vos compagnons à quatre pattes font partie de la famille',
      intro:
        "À l'Hôtel Griffintown, nous comprenons que vos animaux de compagnie font partie de la famille. Nous accueillons les animaux bien éduqués et avons créé un environnement confortable pour vous et vos compagnons à quatre pattes.",
      directBookingBenefit:
        "Réservez directement avec nous et nous annulons les frais pour animaux ! Cet avantage exclusif n'est disponible que lorsque vous réservez via notre site web ou nous appelez directement.",
      policies: [
        'Maximum de 2 animaux par appartement',
        'Les animaux doivent être propres et bien éduqués',
        'Les clients sont responsables des dommages causés par leurs animaux',
        'Les animaux doivent être tenus en laisse dans les espaces communs',
        'Frais pour animaux : 45 $ par nuit (annulés pour les réservations directes)',
      ],
      amenities: [
        'Appartements accueillants pour animaux avec accès facile',
        'Parcs et zones de promenade à proximité',
        'Stations de déchets pour animaux sur la propriété',
        'Options de restauration acceptant les animaux à proximité',
      ],
      servicesTitle: 'Services et commodités pour animaux',
      policiesTitle: 'Politiques et directives pour animaux',
    },
  }

  const pageContent = content[intl.locale]

  return (
    <Layout>
      <MetaTags
        title={`${intl.formatMessage({
          id: 'petFriendly',
        })} | Hotel Griffintown`}
      />
      <Header
        eyebrow={pageContent.eyebrow}
        heading={pageContent.heading}
        fluid={fluid}
      />
      <Section>
        <Wrapper size='narrow'>
          <SectionBlock>
            <GridRow>
              <GridItem xs='1-1' lg='3-4'>
                <Heading
                  size={3}
                  variant='sans'
                  css={`
                    margin-bottom: 0.5em;
                  `}
                >
                  {pageContent.subheading}
                </Heading>
                <p>{pageContent.intro}</p>
                <p
                  style={{
                    fontWeight: 'bold',
                    color: '#d4af37',
                    fontSize: '1.1em',
                  }}
                >
                  {pageContent.directBookingBenefit}
                </p>
              </GridItem>
            </GridRow>
          </SectionBlock>
          <SectionBlock>
            <GridRow>
              <GridItem xs='1-1' md='1-2' equalHeight>
                <FeatureBox heading={pageContent.policiesTitle} icon='fork'>
                  <List items={pageContent.policies} />
                </FeatureBox>
              </GridItem>
              <GridItem xs='1-1' md='1-2' equalHeight>
                <FeatureBox heading={pageContent.servicesTitle} icon='sofa'>
                  <List items={pageContent.amenities} />
                </FeatureBox>
              </GridItem>
            </GridRow>
          </SectionBlock>
        </Wrapper>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query PetsWelcomePage {
    headerImage: file(name: { eq: "img-hero-policies" }) {
      childImageSharp {
        fluid(maxWidth: 2560, quality: 100, cropFocus: CENTER) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default PetsWelcome
